import { api } from 'src/utils/api';

const list = (params = {}) => api.get('/debtors', { params });

const find = (pkDebtor, pkCompany) => api.get(`/debtors/${pkDebtor}`, {
    params: {
        pkCompany,
    },
});

const operatorList = (params = {}) => api.get('/operator/debtors', { params });

const createPhone = (pkDebtor, params) => api.post(`/debtors/${pkDebtor}/phones`, params);

const updatePhone = (pkDebtor, pkPhone, params) => api.put(`/debtors/${pkDebtor}/phones/${pkPhone}`, params);

const createEmail = (pkDebtor, params) => api.post(`/debtors/${pkDebtor}/emails`, params);

const updateEmail = (pkDebtor, pkEmail, params) => api.put(`/debtors/${pkDebtor}/emails/${pkEmail}`, params);

const hygienizeDebtor = pkDebtor => api.get(`/operator/hygiene-debtor/${pkDebtor}`);


export {
    list,
    find,
    operatorList,
    createPhone,
    updatePhone,
    createEmail,
    updateEmail,
    hygienizeDebtor,
};
